import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import howto from './imgs/book_edit_howto.png';

interface Props {
    save():void,
}

const BookInputTab2 = (props:Props)=> {
    return (
        <div id="tab2" className="bookTab">
            <Grid container spacing={2} style={{marginBottom:"2em"}}>
                <Grid item xs={8}>
                    
                </Grid>
                <Grid item xs={4}>
                    <Button variant="contained" color="primary" style={{width:"100%"}} onClick={props.save}>保存する</Button>
                </Grid>
            </Grid>
            <div className="talk">
                <p>一括編集で正しく処理できなかった行を個別に編集します。改ページや空行の追加も可能です。</p>
                <p>編集したい行をタップするとメニューが表示されます。</p>
            </div>
            <div className="book_edit_howto">
                <img src={howto}/>
            </div>
            <ul className="bookHint">
                <li>ト書きになってしまっている行をセリフに変更したい場合は、メニューの「セリフ」を選んで下さい。</li>
                <li>このモードで行った編集は、一括編集や原稿の再アップロードでリセットされます。</li>
            </ul>
        </div>
	);
}

export default BookInputTab2;
